import * as React from "react";

const ReferralsIcon = (props) => (
    <svg
        width={16}
        height={16}
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
    >
        <path d="M22 21.1377V19.1377C22 17.2739 20.7252 15.7078 19 15.2637M15.5 3.42845C16.9659 4.02184 18 5.45901 18 7.1377C18 8.81638 16.9659 10.2535 15.5 10.8469M17 21.1377C17 19.2739 17 18.342 16.6955 17.607C16.2895 16.6268 15.5108 15.8482 14.5307 15.4422C13.7956 15.1377 12.8638 15.1377 11 15.1377H8C6.13623 15.1377 5.20435 15.1377 4.46927 15.4422C3.48915 15.8482 2.71046 16.6268 2.30448 17.607C2 18.342 2 19.2739 2 21.1377M13.5 7.1377C13.5 9.34683 11.7091 11.1377 9.5 11.1377C7.29086 11.1377 5.5 9.34683 5.5 7.1377C5.5 4.92856 7.29086 3.1377 9.5 3.1377C11.7091 3.1377 13.5 4.92856 13.5 7.1377Z" 
        stroke={props?.focused ? '#6941C6' : '#414651'}
        stroke-width={2} 
        stroke-linecap="round" 
        stroke-linejoin="round" 
        />
    </svg> 
);

export default ReferralsIcon;